<template>
  <div>
    <TopMenu />
    <router-view />
    <OverallComponents />
  </div>
</template>

<style>
@import "./assets/css/webfont.css";
@import "./assets/css/base.css";
@import "./assets/css/custom.css";
@import "./assets/css/popup.css";
@import "./assets/css/font-awesome.css";
@import "./assets/css/animate.css";
@import "./assets/css/exception.css";
</style>

<script>
import TopMenu from "@/components/Menu/TopMenu.vue";
import OverallComponents from "@/components/Common/OverallComponents.vue";
export default {
  name: "App",
  components: { TopMenu, OverallComponents },
};
</script>
